module.exports = __webpack_public_path__ + "static/img/default_yokelly.35df0236.jpg";